<template>
  <b-card no-body class="card-partido" :class="{ activo: activo }">
    <b-row style="margin-bottom:4px; ">
      <b-col md="8">
        <!-- <span style="font-size:10px; "
          >{{ partido.fecha }} / {{ partido.horario }}</span
        > -->
      </b-col>
      <!-- <b-col md="4" style="paddin:0;text-align:right">
        <span style="font-size:6px; color:white">{{ partido.id_partido }} </span>
      </b-col> -->
    </b-row>
    <b-row>
      <b-col class="d-flex align-items-center justify-content-center">
        <img :src="partido.foto_local" alt="ND" width="28" />
      </b-col>
      <b-col class="d-flex align-items-center justify-content-center">
        <img :src="partido.foto_visita" alt="ND" width="28" />
      </b-col>
    </b-row>
    <b-row>
      <b-col :class="{ activo: activo }" class="text-center nombre-equipo text-truncate " md="5" lg="5">
        {{ partido.nom_local }}
      </b-col>
      <b-col :class="{ activo: activo }" class="text-center nombre-equipo text-truncate " md="1" lg="1">
        vs
      </b-col>
      <b-col :class="{ activo: activo }" class="text-center nombre-equipo text-truncate" md="5" lg="5">
        {{ partido.nom_visita }}
      </b-col>
    </b-row>
  </b-card>
</template>
<script>
import {
  //   BTabs,
  //   BTab,
  BCard,
  BRow,
  BCol,
  //   BButton,
  //   VBTooltip,
  //   xx,
  //   xx,
  //   xx,
  //   xx,
  //   xx,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
  },
  props: {
    partido: Object,
    activo: Boolean,
  },
  setup() {},
}
</script>
<style scoped>
/* .card-partido {
  width: 220px;
  background: #eeeeee;
  padding: 5px;
  font-size: 9px;
} */
.nombre-equipo {
  font-weight: bolder;
  font-size: 9px;
  margin-top: 6px;
}
.nombre-equipo.activo {
  font-weight: bolder;
  font-size: 9px;
  margin-top: 6px;
  color: white !important;

}
.card-partido {
  /* background: #eeeeee;/ */
  transition: all 0.2s ease;
  cursor: pointer;
  border: 1px solid lightgray;
  width: 170px;
  font-size: 9px;
  padding: 5px;

}

.card-partido.activo {
  background: #7092aa;
  color: white !important;
  transform: scale(0.96);
  border: 1px solid rgb(30, 30, 30);
  padding: 5px;
}
</style>
